import { render, staticRenderFns } from "./PagesCustomDomain.vue?vue&type=template&id=9efe6a94&"
import script from "./PagesCustomDomain.vue?vue&type=script&lang=js&"
export * from "./PagesCustomDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports